export enum ComplexCaseowningTeams {
    PeabodyComplaintsTeam = "Peabody Complaints Team",
    PeabodyServiceRecoveryTeam = "Peabody Service Recovery Team"
  }